<script setup>
import { computed, watch } from 'vue'
import DatePickerWithPriceBadge from './DatePickerWithPriceBadge.vue'

const props = defineProps({
    theme: Object,
    forms: Object,
})

const form = defineModel('form')
const valid = defineModel('valid')

const rangeValue = computed({
    get: () => ({
        start: form.value.day_start || null,
        end: form.value.day_end || null,
    }),
    set: (val) => {
        form.value.day_start = val?.start ?? ''
        form.value.day_end = val?.end ?? ''
    },
})

watch(
    () => ({ start: form.value.day_start, end: form.value.day_end }),
    ({ start, end }) => {
        valid.value = !!(start && end)
    },
)
</script>

<template>
    <div id="rental-date-range" class="px-5 flex flex-col gap-4">
        <p class="font-bold text-xl">{{ $t('widget.terms_header') }}</p>
        <DatePickerWithPriceBadge
            v-model="rangeValue"
            :is-range="true"
            :color="theme.color"
            :columns="2"
            locale="cs"
            :first-day-of-week="1"
            :min-date="new Date().toISOString().slice(0, 10)"
            :enable-week-toggle="false"
            title-position="left"
        />
        <small v-if="form.errors?.day_start" class="text-red-500">{{ form.errors.day_start }}</small>
        <small v-if="form.errors?.day_end" class="text-red-500">{{ form.errors.day_end }}</small>
    </div>
</template>
